/**
 * Issue #415: Beta test account display helpers.
 *
 * Beta test accounts are auto-generated accounts that use the
 * `@universe-app.online` email domain. When their identity is shown to the
 * user (e.g. on the Profile page), the displayed name must be suffixed with
 * "(Beta)" so a tester can recognize that they are using a beta test
 * account.
 */

const BETA_EMAIL_DOMAIN = '@universe-app.online';
const BETA_NAME_SUFFIX = '(Beta)';

export const isBetaTestAccount = (email) => {
  if (!email || typeof email !== 'string') return false;
  return email.toLowerCase().endsWith(BETA_EMAIL_DOMAIN);
};

/**
 * Build the user's full display name. Returns "First Last (Beta)" for beta
 * test accounts and "First Last" otherwise. Returns an empty string when
 * no user data is available so callers can render safely while loading.
 */
export const formatUserDisplayName = (userData) => {
  if (!userData) return '';
  const firstName = userData.first_name || '';
  const lastName = userData.last_name || '';
  const fullName = `${firstName} ${lastName}`.trim();
  if (!fullName) return '';
  return isBetaTestAccount(userData.email)
    ? `${fullName} ${BETA_NAME_SUFFIX}`
    : fullName;
};
